import { ActionButtonType } from '../enum/action-button.enum';
import { IActionButton } from '../interfaces/button.interface';

// Each row action's icon, colour and tooltip, the same on every list.
export const ACTION_BUTTONS: Record<ActionButtonType, IActionButton> = {
    [ActionButtonType.VIEW]: { icon: 'pi pi-eye', severity: 'info', title: 'View' },
    [ActionButtonType.EDIT]: { icon: 'pi pi-file-edit', severity: 'success', title: 'Edit' },
    [ActionButtonType.REMOVE]: { icon: 'pi pi-trash', severity: 'danger', title: 'Remove' },
    [ActionButtonType.TEST_RUN]: { icon: 'pi pi-play', severity: 'help', title: 'Test run' },
    [ActionButtonType.RUNS]: { icon: 'pi pi-history', severity: 'secondary', title: 'Runs' },
};
